import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ProductCard from "../product_card/product_card";
import styles from "./products_list.module.css";
import { PRODUCTS_IN_PAGE } from "../../utils/constants";
import SaleNewList from "./sale_new_list";


const ProductsList = ({ actualProducts }) => {

  const [count, setCount] = useState(PRODUCTS_IN_PAGE);
  const [isButton, setIsButton] = useState(false);
  const location = useLocation();

  const addProducts = (increment, arrLength) => {
    let newCount = count;
    newCount += increment;
    setCount(newCount);
    controlButton(arrLength, newCount);
  }

  const controlButton = (arrLength, length) => {
    arrLength > length ? setIsButton(true) : setIsButton(false);
  }

  const handleClickMore = () => {
    addProducts(PRODUCTS_IN_PAGE, actualProducts.length);
  }

  useEffect(() => {
    setIsButton(actualProducts.length > PRODUCTS_IN_PAGE);
    setCount(PRODUCTS_IN_PAGE);
  }, [actualProducts]);


  return (
    <>
      {location.pathname !== '/catalog/new' && location.pathname !== '/catalog/sale' &&
        <>
          <ul className={styles.list}>
            {
              actualProducts.slice(0, count).map(product =>
                <li key={product.id}>
                  <Link to={product.path}
                    className={styles.productCard}
                  >
                    <ProductCard product={product} />
                  </Link>
                </li>
              )
            }
          </ul>
          {
            isButton &&
            <button
              className={styles.addButton}
              onClick={handleClickMore}
            >
              Ещё
            </button>
          }
        </>
      }
      {
        (location.pathname === '/catalog/new' || location.pathname === '/catalog/sale') &&
        <SaleNewList actualProducts={actualProducts} />
      }
    </>
  );
}

export default ProductsList;
